export default function idGenerator (prefix) {
  let index = 0;
  return { // A real ES2015 generator would require babel-polyfill
    next () {
      return { value: `${prefix}-${index++}` };
    }
  };
}
